export default () => {
    const productCards = document.querySelectorAll('.blockSlidersGallery__product');

    if(!productCards) return;

    productCards.forEach(productCard => {
        const sliderElement = productCard.querySelector('.splide');
        if(!sliderElement) return;

        const slider = new window.splide(sliderElement, {
            type: 'loop',
            perPage: 1,
            perMove: 1,
            pagination: true,
            arrows: false,
            lazyLoad: 'nearby',
            classes: {
                pagination: 'splide__pagination splide__pagination--dark',
            },
            gap: '16px'
        });

        slider.on('overflow', function (isOverflow) {
            slider.options = {
                pagination: isOverflow,
                drag: isOverflow,
            };
        });

        slider.mount();
    });
}